import ReactEcharts from 'echarts-for-react';
import React from 'react';

const SeriesBarChart = ({ item }) => {
    // Extract the dataset from the item
    const dataset = item.dataset.source;

    // Set up the chart options
    const options = {
        legend: {
            orient: 'vertical', // Set legend orientation to vertical
            right: '0%', // Position the legend on the right
            top: 'center' // Center the legend vertically
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            }
        },
        title: {
            text: item.title.text || "",
            left: 'center',
        },
        xAxis: {
            name: item.xAxis.name || "",
            type: item.xAxis.type,
            data: dataset.slice(1).map(row => row[0]), // Extract the states for x-axis
            nameLocation: 'middle', // Center the title on the x-axis
            nameGap: 25, // Space between the title and axis
            nameTextStyle: {
                align: 'center', // Center align the title text
            },
        },
        yAxis: {
            name: item.yAxis.name || "",
            ...item.yAxis,
        },
        series: item.series.map((seriesItem, index) => ({
            ...seriesItem,
            name: dataset[0][index + 1], // Assign "No" and "Yes" to series names
            data: dataset.slice(1).map(row => row[index + 1]) // Extract data for each series
        }))
    };

    return (
        <ReactEcharts option={options} style={{ height: '400px', width: '100%' }} />
    );
};

export default SeriesBarChart;
